import classNames from "classnames";
import React, { ReactElement } from "react";
import { AppSmallTabButton } from "./AppSmallTabButton";

interface Props {
  activeTab: number;
  tabs: (JSX.Element | string)[];
  onClick: (tab: number) => void;
}

export function AppSmallTabs(props: Props): ReactElement {
  const getBorderStyle = (): React.CSSProperties => {
    return {
      width: `${(1 / props.tabs.length) * 100}%`,
      transform: `translateX(${props.activeTab * 100}%)`,
    };
  };

  return (
    <div className="AppSmallTabs">
      <div className="AppSmallTabs__container">
        {props.tabs.map((tab, index) => (
          <AppSmallTabButton
            key={index}
            className={classNames({ Active: index === props.activeTab })}
            onClick={() => props.onClick(index)}
          >
            {tab}
          </AppSmallTabButton>
        ))}
      </div>

      <div className="AppSmallTabs__border">
        <div style={getBorderStyle()} />
      </div>
    </div>
  );
}
